import { UserGroupIcon } from "@stacklet/ui";

import { IdentityProviderLogo } from "./IdentityProviderLogo";

interface Props {
  /** Provider `idpType`, which picks the logo; omit for a local section. */
  idpType?: string | null;
}

/** A section's leading glyph: the provider logo, or a users icon for local sections. */
export function SectionIcon({ idpType }: Props) {
  return (
    <div className="flex shrink-0 items-center justify-center rounded-full bg-overlay-medium p-xs">
      {idpType ? (
        <IdentityProviderLogo idpType={idpType} size={14} />
      ) : (
        <UserGroupIcon className="text-text-secondary" size={14} />
      )}
    </div>
  );
}
